import endpoints from "../utils/endpoints";
import { message } from "antd";
import { Api } from "./api";
import { removeEmpty } from "../utils/objectUtils";
import { notificationError, notificationSucces } from "./notification";

export async function getLocationsList(params: any) {
  let res = {
    count: 0,
    page: null,
    perpage: 0,
    list: [],
  };

  if (params) {
    params = removeEmpty(params)
  }

  await Api.get(endpoints.getLocationsList, { params }).then((response) => {
    res = response.data
  }).catch((err: string) => {
    notificationError('Could not get data from servers')
  })

  return res
}

export async function getLocationById(params: any) {
  let res = {
    charityId: "",
    charityName: "",
    serverId: "",
    name: "",
    address: "",
    zipcode: "",
    city: "",
    state: "",
    phone: "",
    email: "",
    status: "Active",
    operationalState: "Active",
    devicesLimit: "",
    permit: "",
    closeAtBusinessDayEnd: "no",
    closeAtMonthEnd: "no",
    license: "",
    locationType: "",
    drawerEnabled: "no",
    cashinLimit: "",
    posBundleServerEnabled: "no",
    drawerHighCashNotificationEnabled: "no",
    disableDeckManagement: false,
    earlyClose: '',
    lateStart:'',
    allowSingleUse: false,
    dynamicBundleDownload: false,
    seasonal: false,
    checkSiteInactive: true,
    locationSpecificLobbyOrder: false
  };

  await Api.get(endpoints.getLocationById, { params }).then((response) => {
    res = response.data
    if (!res || res.charityId === '') {
      notificationError('Unable to get location information')
    }
  }).catch((err: string) => {
    notificationError('Unable to get location information')
  })

  return res
}

export async function createOrUpdateLocation(payload: any) {
  let res = false
  await Api.post(endpoints.createOrUpdateLocation, payload).then((response) => {
    if (response.status === 200) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        notificationSucces('Location was successfully updated')
        res = true
      }
    } else {
      notificationError('Could not update the location')
    }
  }).catch((err: string) => {
    notificationError('Could not update the location')
  })
  return res
}

export async function updateLocationStatus(params: any){

  await Api.get(endpoints.updateLocationStatus, {params}).then((response) => {
    if(response.status === 200) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        notificationSucces('Status changed successfully')
      }
    } else {
      notificationError('Could not update location status')
    }
  }).catch((err: string) => {
    notificationError('Could not update location status')
  })
}

export async function validatePermitCode(params: any){
  let res = true
  await Api.get(endpoints.validatePermitCode, {params}).then((response) => {
    if(response.status === 200 && response.data) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        res = response.data.return
      }
    } else {
      notificationError('Could not validate permit code')
    }
  }).catch((err: string) => {
    notificationError('Could not validate permit code')
  })
  
  return !res
}




